import React, { Component } from 'react';

import { Offcanvas, Row, Col, Card } from 'react-bootstrap';

import CommonButton from '../components/CommonButton';
import CommonAlert from '../components/CommonAlert';
import CommonLoadingBar from '../components/CommonLoadingBar';

import CommonInput from '../components/CommonInput';
import CommonSelect from '../components/CommonSelect';
import CommonFile from '../components/CommonFile';

import CustomDatePicker from "../components/CommonDatePicker";

/**
import CommonRadio from '../components/CommonRadio';
import CommonCheckbox from '../components/CommonCheckbox';
*/

import * as Actions from '../actions/ActionCenter';

import * as fn from '../../library/function';
import * as helper from '../../library/helper';
import * as util from '../../library/utilitys';

import SimpleBar from 'simplebar-react';
class InputPublicDataPublicizeNews extends Component {

    constructor(props) {
        super(props);
        this.state = {
            selectedDate: new Date()
        };
    }
    
    handleDateChange = (date) => {
        this.setState({ selectedDate: date });
    }
    
    componentDidUpdate = async (prevProps) => {
        if (fn.shouldPrepareInputs(prevProps.Action, this.props.Action)) {
            await this.prepareInputs();
        }
    }
    
    prepareInputs = async () => {
        const { URL, Action, Inputs, onUpdateState, UserCookie } = this.props;
        const isUpdateMode = Action.Mode === 'update';

        let updatedInputs = fn.setRequiredPrimaryKey(Inputs, isUpdateMode);
        
        if (Action.Mode === "new") {
            if ([ '3', '4', '5'].includes(UserCookie.types)) {
                 updatedInputs.types = {
                    ...updatedInputs.types,
                    value: UserCookie.types,
                    };

            }else if (UserCookie.types === "2") {
                updatedInputs.types = {
                ...updatedInputs.types,
                value: "2"
                };                
                updatedInputs.academy_id = {
                ...updatedInputs.academy_id,
                value: UserCookie.academy_id,
                };
                
            }else if (['0', '1'].includes(UserCookie.types)) {
                updatedInputs.types = {
                ...updatedInputs.types,
                value: "1"
                };
            }
            updatedInputs.status = {
                ...updatedInputs.status,
                value: "0"
                };
            updatedInputs.news_type = {
                ...updatedInputs.news_type,
                value: "0"
                };

        }

        onUpdateState('Inputs', updatedInputs);
    }

    toggleOwnerType = (index) => {
        const { Inputs, onUpdateState } = this.props;

        const getUpdatedField = (fieldKey, { value, required }) => ({
            ...Inputs[fieldKey],
            value: value !== undefined ? value : Inputs[fieldKey].value,
            validator: {
                ...Inputs[fieldKey].validator,
                required: required !== undefined ? required : Inputs[fieldKey].validator.required,
            },
            error: {
                ...Inputs[fieldKey].error,
                status: null,
                msg: '',
            }
        });

        const fieldUpdatesByIndex = {
            '0': {
                academy_id: { value: '', required: false },
                enterprise_id: { value: '', required: false },
                user_id: { value: '', required: false }
            },
            '1': {
                academy_id: { required: true },
                enterprise_id: { value: '', required: false },
                user_id: { value: '', required: false }
            },
            '2': {
                academy_id: { required: true },
                enterprise_id: { value: '', required: false },
                user_id: { value: '', required: true }
            },
            '3': {
                enterprise_id: { required: true },
                academy_id: { value: '', required: false },
                user_id: { value: '', required: true }
            },
            '4': {
                enterprise_id: { required: true },
                academy_id: { value: '', required: false },
                user_id: { value: '', required: true }
            },
            '5': {
                enterprise_id: { required: true },
                academy_id: { value: '', required: false },
                user_id: { value: '', required: true }
            }
        };
    
        const updates = fieldUpdatesByIndex[index] || {};
        
        const updatedInputs = {
            ...Inputs,
            ...Object.fromEntries(
                Object.entries(updates).map(
                    ([fieldKey, config]) => [fieldKey, getUpdatedField(fieldKey, config)]
                )
            )
        };
    
        onUpdateState('Inputs', updatedInputs);
    };

    getFilteredUsers = () => {
        const { Inputs, Masterbase } = this.props;
        const users = Masterbase?.users || [];
        const typeValue = Inputs.types?.value;
      
        if (typeValue === '0') {
          return users.filter(u => ['0', '1'].includes(u.types));
        }
      
        if (typeValue === '1') {
          const academyId = Inputs.academy_id?.value;
          return users.filter(u => u.types === '1' && u.academy_id === academyId);
        }
    
        if (typeValue === '2') {
          const academyId = Inputs.academy_id?.value;
          return users.filter(u => u.types === '2' && u.academy_id === academyId);
        }
      
        if (typeValue === '3') {
          const enterpriseId = Inputs.enterprise_id?.value;
          return users.filter(u => u.types === '3' && u.enterprise_id === enterpriseId);
        }
    
        if (typeValue === '4') {
          const enterpriseId = Inputs.enterprise_id?.value;
          return users.filter(u => u.types === '3' && u.enterprise_id === enterpriseId);
        }
    
        if (typeValue === '5') {
          const enterpriseId = Inputs.enterprise_id?.value;
          return users.filter(u => u.types === '3' && u.enterprise_id === enterpriseId);
        }
      
        return [];
    };
      
    
    render = () => {
        let props = this.props;

        let { onInputChange, onCloseAlert, onSubmit, onDiscardSubmit, onPreviewFile, onDeleteFile } = props;

        let { App, Action, Inputs, InputGroup, Masterbase, Operation, UserCookie } = props;

        let { Submit } = Operation;
        
        let { show, mode } = Action.OffCanvas;

        let isLoading = Action.Loading.submit;

        return (
                <Offcanvas 
                    show={show}
                    placement="end" 
                    style={{ '--bs-offcanvas-width':  window.innerWidth < 768 ? '80vw' : '50vw' }}
                    scroll={true}
                    backdrop={Submit ? "static" : true}
                    onHide={(e) => props.onClose(e)}
                >
                    <Offcanvas.Header closeButton className="border-bottom custom-offcanvas-header">
                        <Offcanvas.Title className="custom-offcanvas-header offcanvas-title"><i className={`${App.icon} text-white me-2`}/>{App.title}</Offcanvas.Title>
                    </Offcanvas.Header>

                    <Offcanvas.Body className="custom-offcanvas-body">
                        
                        <CommonAlert 
                            alert={Action.Alert} 
                            callback={(e) => onCloseAlert(e)}
                        />
                        
                        <SimpleBar id="inputs" className="simple-bar-input">

                            {/** 
                            <Card bg="light">
                                <Card.Body>
                            */}
                                    <Row>
                                        <Col md={6}>
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.news_type}
                                                option={{source: 'options', section: 'category', item: 'publicize_news_type'}}
                                                hr={false}
                                                callback={async (e, element) => onInputChange(e, element) } 
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>

                                    <Row className="mt-3">
                                        <Col md={6}>
                                            <CommonSelect
                                                element="Inputs"
                                                input={Inputs.types}
                                                option={{source: 'options', section: 'category', item: 'publicize_news_by'}}
                                                hr={false}
                                                callback={async (e, element) => { 
                                                    await onInputChange(e, element);
                                                    this.toggleOwnerType(e.target.value);
                                                    await onInputChange(e, element);
                                                }} 
                                                // disabled={!['0', '1'].includes(UserCookie.types)}
                                                disabled={true}
                                            />
                                        </Col>
                                    </Row>

                                    {[ '2', '3'].includes(Inputs.types.value) && (
                                        <Row className="mt-3"> 
                                            <Col md={12}>
                                                {Inputs.types.value === '2' && (
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.academy_id}
                                                        option={{source: 'db', data: Masterbase?.academy}}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                        disabled={!['0','1'].includes(UserCookie.types)}
                                                    />
                                                )}

                                                {Inputs.types.value === '3' && (
                                                    <CommonSelect
                                                        element="Inputs"
                                                        input={Inputs.enterprise_id}
                                                        option={{source: 'db', data: Masterbase?.enterprise}}
                                                        hr={false}
                                                        callback={(e, element) => onInputChange(e, element)} 
                                                        disabled={!['0', '1'].includes(UserCookie.types)}
                                                    />   
                                                )}
                                            </Col>
                                        </Row>  
                                    )}
 
                                    {[ '2', '3'].includes(Inputs.types.value) && (
                                        <Row className="mt-3"> 
                                            <Col md={12}>
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.user_id}
                                                    option={{source: 'db', data: this.getFilteredUsers()}}
                                                    hr={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                        disabled={!['0','1','4' ].includes(UserCookie.types)}//'5','2'
                                                />
                                            </Col>
                                        </Row> 
                                    )}
                                    <Row>
                                        <Col md={12}><hr className="hr-custom" /></Col>
                                    </Row>

                                    <Row>
                                        <Col md={12}>
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.name}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>   
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.detail}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>  
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.contact}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>  
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonInput
                                                element="Inputs"
                                                input={Inputs.url_link}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.photo}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row>   
                                    <Row className="mt-3">
                                        <Col md={12}>
                                            <CommonFile
                                                element="Inputs"
                                                input={Inputs.files}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 

                                                previewFile={(e) => onPreviewFile(e)} 
                                                deleteFile={(e) => onDeleteFile(e, Inputs.id)} 
                                            />
                                        </Col>
                                    </Row> 
                                    <Row className="mt-3">
                                        <Col md={3}>
                                            <CustomDatePicker 
                                                element="Inputs"
                                                input={Inputs.publicize_date}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                        <Col md={3}>
                                            <CustomDatePicker 
                                                element="Inputs"
                                                input={Inputs.expired_date}
                                                hr={false}
                                                callback={(e, element) => onInputChange(e, element)} 
                                            />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col md={12}><hr className="hr-custom" /></Col>
                                    </Row>
                                    {['0', '1'].includes(UserCookie.types) && (
                                        <Row> 
                                            <Col md={6}>
                                                <CommonSelect
                                                    element="Inputs"
                                                    input={Inputs.status}
                                                    option={{source: 'options', section: 'status', item: 'publicize'}}
                                                    hr={false}
                                                    callback={(e, element) => onInputChange(e, element)} 
                                                    disabled={!['0', '1'].includes(UserCookie.types)}
                                                />
                                            </Col>
                                        </Row>
                                    )}
                            {/** 
                                </Card.Body>
                            </Card>
                            */}

                        </SimpleBar>

                    </Offcanvas.Body>
                    
                    <div className="offcanvas-footer d-flex flex-column border-top bg-light p-3">
                        
                        <CommonLoadingBar isLoading={isLoading} />

                        <div className="d-flex justify-content-end mt-2">
                            <CommonButton 
                                task={mode} 
                                disabled={isLoading ? true : Submit ? false : true}
                                callback={async (e) => { 
                                    await onSubmit(e);
                                    
                                    if(Action.Mode === 'update'){ await this.prepareInputs(); }
                                }} 
                            />

                            {Action.Mode === 'new' && (
                                <CommonButton 
                                    task="discard" 
                                    inlineClass="ms-1" 
                                    disabled={isLoading} 
                                    callback={(e) => onDiscardSubmit(false)} 
                                />
                            )}
                        </div>
                    </div>
                </Offcanvas>      
        )
    }
}

export default InputPublicDataPublicizeNews;